import CONFIG from './CONFIG.js';

const _data={};

try {
	const response = await fetch(`${CONFIG.backend_base_url}data.json?t=${Date.now()}`);
	const data = await response.json();
	for (let i in data) _data[i] = data[i];
} catch (error) { console.error(error); }

export default _data;